export default __webpack_public_path__ + "static/media/num-2.57fecaf7.svg";